import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import "./ShopifySyncCatalogItemsModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../../models/ISupplierModel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import IShopifySyncProductsDTO from "../../../../models/DTO/IShopifySyncProductsDTO";
import SupplierContext from "../../../../contexts/SupplierContext";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import IShopify from "../../../../models/IShopify";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import * as _ from "lodash-es";
import IShopifyDownloadProductCsvDTO from "../../../../models/DTO/IShopifyDownloadProductCsvDTO";
import UserContext from "../../../../contexts/UserContext";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IShopifyOnDownloadProductCsvDTO from "../../../../models/DTO/IShopifyOnDownloadProductCsvDTO";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    startProcessing: (options: Partial<IShopifySyncProductsDTO>) => void;
};

export const ShopifySyncCatalogItemsModal: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const [includePhotos, setIncludePhotos] = useState(false);
    const [createProductGroups, setCreateProductGroups] = useState(false);
    const [shopGuid, setShopGuid] = useState<string>();
    const [shopifyShop, setShopifyShop] = useState<IShopify | undefined>();
    const [syncDirection, setSyncDirection] = useState("pull");
    // @ts-expect-error
    const [showHiddenFeatures, setShowHiddenFeatures] = useState(window.showHiddenFeatures || false);

    const syncDirectionOptions = [{ value: "pull", title: "pull" }];

    useEffect(() => {
        props.socket.on(EndpointsEnum.ShopifyOnDownloadProductCsv, onDownloadCsv);

        return () => {
            props.socket.removeListener(EndpointsEnum.ShopifyOnDownloadProductCsv, onDownloadCsv);
        };
    }, []);

    const closeModal = () => {
        props.closeModalFn();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "include_photos":
                setIncludePhotos(value);
                break;
            case "create_product_groups":
                setCreateProductGroups(value);
                break;
        }
    };

    const start = () => {
        const options: Partial<IShopifySyncProductsDTO> = {
            includePhotos,
            createProductGroups,
            shopGuid,
        };

        props.startProcessing(options);
    };

    const selectShop = (shopModel: IShopify) => {
        const guid = shopModel.guid;

        setShopGuid(guid);
        setShopifyShop(shopModel);
    };

    const downloadCsv = () => {
        if (shopGuid) {
            const payload: IShopifyDownloadProductCsvDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                shopGuid: shopGuid,
            };

            props.socket.emit(EndpointsEnum.ShopifyDownloadProductCsv, payload);
        }
    };

    const saveCsv = (csvData: any, filename: string) => {
        const blob = new Blob([csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = filename;
        link.click();
    };

    const onDownloadCsv = (data: IShopifyOnDownloadProductCsvDTO) => {
        if (data) {
            saveCsv(data.csvData, data.filename);
        }
    };

    return (
        <div className={"ShopifySyncCatalogItemsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-refresh"} title={"shopify_sync_catalog_items"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwSelectOption
                        name={"shop"}
                        fn={selectShop}
                        options={supplierModel.Shopifies}
                        emitObject={true}
                        titleProp={"shopify_shop"}
                        valueProp={"guid"}
                    />
                </div>

                <div className={"mb-2 mt-2"}>
                    {shopifyShop ? (
                        <div>
                            <div>
                                <OwLabel title={"catalog"} isBold={true} className={"me-2"} postText={":"} />
                                {shopifyShop.Catalog?.name}
                            </div>
                            <div>
                                <OwLabel title={"price_group"} isBold={true} className={"me-2"} postText={":"} />
                                {shopifyShop.Price_Group?.value}
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className={"mb-2 mt-2"}>
                    <div>
                        <OwLabel title={"sync_direction"} />
                    </div>
                    <OwSelectOption
                        name={"syncDirection"}
                        options={syncDirectionOptions}
                        titleProp={"title"}
                        valueProp={"value"}
                        fn={() => {}}
                        selectedOption={syncDirection}
                        hasSelectedOptionProp={false}
                        translateTitle={true}
                        isDisabled={true}
                    />
                </div>

                <div>
                    <OwCheckbox
                        name={"include_photos"}
                        label={"include_photos"}
                        truthyVal={true}
                        falsyVal={false}
                        fn={handleChange}
                        checked={includePhotos}
                    />
                </div>
                <div>
                    <OwCheckbox
                        name={"create_product_groups"}
                        label={"create_product_groups"}
                        truthyVal={true}
                        falsyVal={false}
                        fn={handleChange}
                        checked={createProductGroups}
                    />
                </div>

                <div className={"mt-2"}>
                    <OwButton title={"start"} fn={start} disabled={!shopGuid} />
                </div>

                {showHiddenFeatures ? (
                    <div className="mt-2">
                        <OwButton title={"download_data"} fn={downloadCsv} disabled={!shopGuid} />
                    </div>
                ) : null}
            </div>
        </div>
    );
};
